import { render, staticRenderFns } from "./ForestersSalesEN.vue?vue&type=template&id=443f8182&scoped=true"
import script from "./ForestersSalesEN.vue?vue&type=script&lang=js"
export * from "./ForestersSalesEN.vue?vue&type=script&lang=js"
import style0 from "./ForestersSalesEN.vue?vue&type=style&index=0&id=443f8182&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443f8182",
  null
  
)

export default component.exports